import { render, staticRenderFns } from "./CarpassObservationDescriptionModal.vue?vue&type=template&id=13b7c330"
import script from "./CarpassObservationDescriptionModal.vue?vue&type=script&lang=ts"
export * from "./CarpassObservationDescriptionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13b7c330')) {
      api.createRecord('13b7c330', component.options)
    } else {
      api.reload('13b7c330', component.options)
    }
    module.hot.accept("./CarpassObservationDescriptionModal.vue?vue&type=template&id=13b7c330", function () {
      api.rerender('13b7c330', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cars/CarpassObservationDescriptionModal.vue"
export default component.exports